import { render, staticRenderFns } from "./PurchasePreview.vue?vue&type=template&id=d8ed9d78&scoped=true&"
import script from "./PurchasePreview.vue?vue&type=script&lang=ts&"
export * from "./PurchasePreview.vue?vue&type=script&lang=ts&"
import style0 from "./PurchasePreview.vue?vue&type=style&index=0&id=d8ed9d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ed9d78",
  null
  
)

export default component.exports